import { AxiosRequestConfig } from 'axios'
import { FeatureCollection, Geometry } from 'geojson'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

import { LayerValue } from '../types/weed-diagnosis'

export interface LayerInfo {
  name: string
  area: LayerValue
}

export interface DiagnosisData {
  area: LayerValue
  layers: LayerInfo[]
}

export interface InfestationGroup {
  name: string
  base_diagnosis: DiagnosisData
  comparison_diagnosis: DiagnosisData
}

export interface FieldComparison {
  field_id: string
  field_name: string
  field_area: LayerValue
  infestation_groups: InfestationGroup[]
}

export interface GetInfestationComparisonByFieldFromRegionResponse {
  layer_colors: Record<string, string>
  base_diagnosis: {
    date: string
    geojson: FeatureCollection<Geometry, { layer: string }>
  }
  comparison_diagnosis: {
    date: string
    geojson: FeatureCollection<Geometry, { layer: string }>
  }
  fields_comparison: FieldComparison[]
}

export async function getInfestationComparisonByFieldFromRegion(
  baseDemandId: string,
  compareDemandId: string,
  regionId: string,
  fields: string[],
  options?: AxiosRequestConfig,
) {
  const { data } =
    await companiesApi.post<GetInfestationComparisonByFieldFromRegionResponse>(
      apiRoutes.getInfestationComparisonByFieldFromRegion(),
      {
        base_diagnosis_id: baseDemandId,
        comparison_diagnosis_id: compareDemandId,
        region_id: regionId,
        fields_ids: fields,
      },
      options,
    )

  return data
}
